import { useCallback } from 'react';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { DecimalService, multiplyNumbersAsDecimals } from '@mews/framework';

export const useConvertAmountToCurrencySuspense = () => {
    const { data: currencyAcceptances } = useRepositorySuspenseQuery('currencyAcceptances', 'getAll', {});

    return useCallback(
        (amount: number, currency: string) => {
            if (!currencyAcceptances) {
                return;
            }

            const currencyConversion = currencyAcceptances.find(
                (currencyAcceptance) => currencyAcceptance.currencyCode === currency
            );

            if (!currencyConversion) {
                return;
            }

            const conversionRate = currencyConversion.conversionRateFromDefault;

            const rawResult = multiplyNumbersAsDecimals(amount, conversionRate);

            return DecimalService.toNumber(DecimalService.round(DecimalService.parse(rawResult), 2));
        },
        [currencyAcceptances]
    );
};
